import {FormInput} from "./Input/Input";
import {Dropdown} from "./Dropdown";
import Editor from "./../Fundamentals/Form/Editor";
import {useTranslation} from "react-i18next";
import Spinner from "../Fundamentals/Spinner/Spinner";
import SkynetForm from "../Fundamentals/Form/SkynetForm";
import React from "react";

/* EmailTemplate Component

NOTE! All functionality is not yet implemented in this component.

 This component renders an email template form with fields for recipient, sender, subject, and body.

 Props:
 - data: The email template data to display.
 - onChange: Function to handle changes in the editor.
*/
export default function EmailTemplate({ data, onChange }) {
    const {t} = useTranslation();
    // const { openModal, isModalOpen, closeModal } = useModal();
    
    if (!data)
        return <Spinner/>

    return <SkynetForm>
        <div className="d-grid gap-16">
            {!data.approved &&
                <div className="alert alert-warning alert-sm">
                    <strong>{t('emailtemplate.thistemplateisnotapproved')}</strong> {/*data.responsible && <strong><a onClick={() => openModal(Modals.SendEmailModal)}>{t('emailtemplate.clickhere')}</a>{t('emailtemplate.tocontactthepersonresponsible')}</strong>*/}
                </div>
            }
            <div className="form-group">
                {data.helperText && <div>{data.helperText}</div>}
                {data.defaultToAddresses?.length > 1 ?
                    <Dropdown label={t('emailtemplate.to')} options={data.defaultToAddresses} valueProperty="name" value={data.to} onChange={(value) => onChange('to', value)} /> :
                    <FormInput label={t('emailtemplate.to')} required={true} value={data.to} onChange={(value) => onChange('to', value)}/>}
                {data.defaultSenderAddresses?.length > 1 ?
                    <Dropdown label={t('emailtemplate.from')} options={data.defaultSenderAddresses} valueProperty="name" value={data.from} onChange={(value) => onChange('from', value)}/> :
                    <FormInput label={t('emailtemplate.from')} required={true} value={data.from} disabled={true} onChange={(value) => onChange('from', value)}/>}
            </div>
            <div className="form-group">
                {data.subjectDropdown?.length > 1 ?
                    <Dropdown label={t('emailtemplate.subject')} options={data.subjectDropdown} valueProperty="name" value={data.subject} onChange={(value) => onChange('subject', value)}/> :
                    <FormInput label={t('emailtemplate.subject')} required={true} value={data.subject}  onChange={(value) => onChange('subject', value)}/>}
                {/*<EmailRules rules={data.rules} onChange={onChange}/>*/}
                <Editor
                    label={!data.rules ? t('emailtemplate.body') : t('emailtemplate.preview')}
                    readOnly={!!data.rules}
                    defaultValue={data.body}
                    onChange={(value) => onChange('body', value)}
                />
            </div>
            </div>
        {/*{isModalOpen(Modals.SendEmailModal) && <SendTemplateApprovalEmailModal onClose={() => closeModal(Modals.SendEmailModal)} onSave={() => closeModal(Modals.SendEmailModal)} templateId={data.templateId} />}*/}
    </SkynetForm>
}

// function EmailRules( { rules, onChange } ) {
//     if (!rules || rules.length === 0) {
//         return null;
//     }
//    
//     return <div className="form-group">
//         {rules?.filter(rule => rule.rule !== 'invisible').map( (rule) => {
//             const props = {
//                 key: rule.id,
//                 label: rule.label,
//                 required: rule.rule === "required",
//                 value: rule.value,
//                 onChange: onChange
//             };
//            
//             if (rule.type === "editor") {
//                 return <Editor {...props} defaultValue={rule.value}/>
//             }
//
//             if (rule.type === 'checkbox') {
//                 return <Checkbox {...props} disabled={!rule.checkboxValues || !rule.checkboxValues.includes(rule.value)}/>
//             }
//
//             if (rule.defaultValue) {
//                 // set default value in form data
//             }
//
//             return <FormInput {...props} disabled={rule.defaultValue}/>
//         })}
//     </div>
// }
